import { useState } from 'react';
import { postAPI } from '../../services/api.service';

export function useResetPassword() {
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (email: string, otp: string, password: string) => {
    setLoading(true);
    try {
      const response = await postAPI(`auth/forgot-password/reset`, { email, otp, password });
      if (response.status === 200) {
        return true;
      } else {
        console.error('Failed to reset password:', response.error);
        return false;
      }
    } catch (err) {
      console.error('Error resetting password:', err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { handleResetPassword, loading };
}